module.exports = __webpack_public_path__ + "img/lupa.a2bee096.svg";